
module.exports = {
  "pickup": "You picked a ",
  "drop": "You dropped a ",
  "use": "Use an item [SPACE] or (B)",
  "ravens": "What a heck!? What was that",
  "wateringcan_name": "watering can",
  "stick_name": "stick",
  "seed_name": "seeds",
  "lamp_name": "lamp",
  "shovel_name": "shovel",
  "watering_can": "With it I can water plants. Need to find water, anyway.",
  "stick": "I need three of these to make a campfire.\nI need to add sticks to it to support it",
  "seed": "I can plant it and give a new life,\nI'd better not forget that all plants need water\nand a light source. If i burn couple of seeds\nin the campfire or my lamp they'll glow brighter\nbut wouldn't that be selfish?",
  "lamp": "With a lamp i can light up a campfire, if it'll have enough branches in it.\nIf i burn some seeds in it, it'll glow brighte but do i have a right to take a life?",
  "shovel": "With a shovel I can clean the soil from sand.\nI can dig a hole and plant a seed there\nIf there's grass breaking through the sand does it mean there's water underneath?",
  "wife_0": "[Wife]: Our friends will come on Saturday.",
  "wife_1": "[Wife]: Don't worry you'll be hired anyway.",
  "wife_2": "[Wife]: Why so s@d?",
  "wife_3": "[Wife]: H0w @re you7",
  "wife_4": "[Wif@]: Guess who's scared to 0pen his m0uth at dentist's7",
  "wife_5": "[Wif@]: Dcnhtnbim vtyz7",
  "wife_6": "[Wif@]: Z tle ljvjq gmzytymrfz :*",
  "wife_7": "[Wif@]: Z t36z |yu6|yu\"  ",
  "kid_0" : "[Kid]: How was your day, Daddy?",
  "kid_1" : "[Kid]: What shall we talk about?",
  "kid_2" : "[Kid]: I %as so scar3d when you were gone",
  "kid_3" : "[Kid]: Mom's go#3 to %alk th3 dog7",
  "kid_4" : "[K^7]: G3t o$f|",
  "kid_5" : "[K^7]: Z k.,k. dfc, ds pyftnt 'nj&",
  "kid_6" : "[K^7]: Z p0 8@m 04e№\"\" $|{Y4@yu\"",
  "parents_0" : "[Parents]: When you'll come and visit us?",
  "parents_1" : "[Parents]: You've changed so much...",
  "parents_2" : "[Parents]: We love you and because of that we punish you.",
  "parents_3" : "[Рar0n45]: How dare you argue with vyjq so ofT3№№&",
  "parents_4" : "[P@4kj8s]: Csyjr? z k.,k. nt,z",
  "parents_5" : "[P@4kj8s]: $p@$\"\"60 4t0 p0380№\"\"1\"",
  "friends_0" : "[Friends]: Wassap?",
  "friends_1" : "[Friends]: Still don't wanna return?",
  "friends_2" : "[Friends]: Let's play videogamezz?",
  "friends_3" : "[F4i3nvd]: What's the score?",
  "friends_4" : "[F4tdcvd]: mh3 эt0 h3 \"\"ht3R3$h0\"",
  "author_0" : "[E.M.Remarque]: But that’s what mankind is like: they only prize what they no longer possess.",
  "author_1" : "[E.M.Remarque]: One must never press one’s luck.",
  "author_2" : "[E.M.Remarque]: Love is perhaps the desire to hand on something which one cannot keep.",
  "author_3" : "[E.M.Remarque]: Terror can be endured so long as a man simply ducks;—but it kills, if a man thinks about it.",
  "author_4" : "[E.M.Remarque]: That is only possible so long as things are not going too badly.",
  "author_5" : "[E.M.Remarque]: A man dreams of a miracle and wakes up to loaves of bread.",
  "colleague_0" : "[Colleague]: The holiday is soon, don't worry so much",
  "colleague_1" : "[Colleague]: The boss's furious today",
  "colleague_2" : "[Colleague]: Whatever",
  "colleague_3" : "[Colleague]: Y0u d|d a|| rigHt",
  "colleague_4" : "[Colleagueе]: }{0R0|||320 0t^Y$|{@",
  "colleague_5" : "[Colleague]: V$3 6Yd3t h3 3@m0R@4\"\"v@y'$z\"",
  "pet_0" : "[Pet]: Whines",
  "pet_1" : "[Pet]: Meow",
  "pet_2" : "[P3t]: Scrubs its ear",
  "pet_3" : "[P3t]: Mrrrrrrr",
  "pet_4" : "[P2t]: Nhtncz yjcjv",
  "pet_5" : "[P5t]: R@d v\"\"d3t'",
  "memory_zakolka": "We were to zoo and made that photo. There were only three of us, but year later we got a baby.",
  "memory_kulon": "My mom got this pendant from her granny.",
  "memory_guitar": "I can't play guitar but I often got it when we went camping with friends.",
  "memory_gamepad": "Friends often called me to play online, usually I didn't have time for it.",
  "memory_book": "I like all genres, but for the last couple years I've been reading only anti - war literature.",
	"memory_badge": "I was glad to work there, so i got this badge when the company closed.",
  "memory_miska": "Cat always dropped his bowl to the floor and, having no food, started to scream. It lived with us for a fairly long time, considering cats' standarts."
}